import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Dane Cook",
  "description": "",
  "published": "2007-07-30T00:00:00.000Z",
  "redirect_from": ["/blog/dane-cook/swizec/165"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`O tem videu ne morem povedati niÄ, kar bi ga bilo vredno, zato si ga poste paÄ morali ogledati.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      